module.exports = __webpack_public_path__ + "static/media/PrintFiles.b605e7a9.svg";